import './ChatItem.less';

import clsx from 'clsx';
import React from 'react';
import { dispatch } from 'nike-re-framejs';

import TicketDetailNgSliderItem from '@/mytickets/detail/views/Slider/TicketDetailNgSliderItem';
import FakeCheckInput from '@/nikeone/components/FakeCheckInput';
import { addTicketToTopic, removeAnalyseFromTopic, removeTicketFromTopic } from '@/forum/ticketpicker/handlersAndSubs';
import ChatAnalyseDetail from '@/mytickets/detail/views/Slider/ChatAnalyseDetail';

function ChatShareItems({ disabled, selected, item, topic, inputView, onClick, isAnalyse }) {
    function onChatItemClick() {
        window.history.replaceState(null, null, window.location.pathname);
        dispatch(
            isAnalyse
                ? removeAnalyseFromTopic(topic, item)
                : selected
                ? removeTicketFromTopic(topic, item)
                : addTicketToTopic(topic, item)
        );
        onClick?.(item);
    }

    return (
        <div className={clsx('chat-item', { disabled, selected })} onClick={onChatItemClick}>
            {isAnalyse ? <ChatAnalyseDetail analysis={item} /> : <TicketDetailNgSliderItem ticket={item} />}
            {inputView || isAnalyse ? (
                <div className="chat-selected-analyse-close" />
            ) : (
                <FakeCheckInput checked={selected} className="chat-ticket-check-box blue" />
            )}
        </div>
    );
}

export default ChatShareItems;
